import type { Messages } from './en.js'

// Draft translations for UI chrome (Korean), pending professional review in
// Tolgee. Register is 합니다체 throughout: this is a regulated broker's
// account opening, and the polite-formal form is what a Korean applicant
// expects from one.
export const ko: Messages = {
  'common.needHelp': '도움이 필요하신가요?',
  'common.continue': '계속하기',
  'common.back': '뒤로',

  'shell.cookiePolicy': '쿠키 정책',
  'shell.privacyPolicy': '개인정보처리방침',
  'shell.cookiePreferences': '쿠키 설정',
  'shell.language': '언어',

  'login.title': '로그인',
  'login.subtitle': '계정에 등록된 이메일 주소를 사용하세요.',
  'login.forgot': '비밀번호를 잊으셨나요?',
  'login.createAccount': '계정 만들기',

  'forgot.title': '비밀번호 재설정',
  'forgot.subtitle': '새 비밀번호 설정을 위한 6자리 코드를 이메일로 보내드립니다.',
  'forgot.newTitle': '새 비밀번호 설정',
  'forgot.backToSignIn': '로그인으로 돌아가기',

  'consent.message':
    '당사는 사이트 운영을 위해 쿠키를 사용하며, 동의하시는 경우 사이트 측정 및 개선에도 사용합니다.',
  'consent.acceptAll': '모두 동의',
  'consent.essentialOnly': '필수만 허용',

  // Shared
  'common.email': '이메일 주소',
  'common.password': '비밀번호',
  'common.tryAgain': '다시 시도',
  'err.tooManyAttempts': '시도 횟수를 초과했습니다',
  'err.checkFailed': '확인에 실패했습니다',
  'err.otpDeliveryFailed': '코드를 보내지 못했습니다',
  'err.otpLocked': '잘못된 코드를 너무 많이 입력했습니다',
  'err.otpExpired': '코드가 만료되었습니다',
  'err.countryNotPermitted': '거주 국가에서는 이용할 수 없습니다',
  'err.temporarilyUnavailable': '일시적으로 이용할 수 없습니다',
  'err.checkAnswers': '입력하신 답변을 확인해 주세요',
  'err.somethingWrong': '문제가 발생했습니다',

  // Step indicator
  'step.account': '계정',
  'step.identity': '신원 확인',
  'step.compliance': '규정 준수',
  'step.finish': '완료',

  // Step 1 — account
  'account.emailTitle': '계좌 개설',
  'account.emailSubtitle': '주소 확인을 위한 6자리 코드를 이메일로 보내드립니다.',
  'account.botFailedTitle': '봇 확인이 로드되지 않았습니다',
  'account.botFailedBody': '그대로 진행하셔도 됩니다 — 제출하실 때 확인해 드립니다.',
  'account.send': '코드 보내기',
  'account.sending': '보내는 중…',
  'account.haveAccount': '이미 계정이 있으신가요?',
  'account.login': '로그인',
  'account.otpTitle': '코드를 입력하세요',
  'account.otpSentTo': '{target}(으)로 보냈습니다.',
  'account.otpTargetFallback': '회원님의 이메일 주소',
  'account.escalated': '다른 발송 경로로 코드를 한 번 더 보내드렸습니다.',
  'account.startAgain': '처음부터 다시',
  'account.checking': '확인 중…',
  'account.verify': '확인',
  'account.resend': '코드 다시 보내기',
  'account.tryAnotherWay': '받지 못했습니다 — 다른 방법으로 받기',
  'account.differentEmail': '다른 이메일 주소 사용',
  'account.profileTitle': '몇 가지 정보',
  'account.profileSubtitle': '계정 설정의 마지막 단계입니다.',
  'account.emailReadonlyHint': '방금 입력하신 코드로 확인되었습니다.',
  'account.country': '거주 국가',
  'account.countrySearch': '국가 검색',
  'account.phone': '전화번호',
  'account.consentBefore': '본인은 다음에 따라 개인정보가 수집 및 이용되는 데 동의하며,',
  'account.consentAfter': ' 신청과 관련하여 연락을 받을 수 있음을 이해합니다.',
  'account.creating': '생성 중…',
  'account.existsTitle': '이미 계정이 있습니다',
  'account.signInInstead': '로그인하기',

  'partner.add': '파트너 코드가 있으신가요?',
  'partner.label': '파트너 코드 / 링크 ID',
  'partner.confirm': '코드 적용',
  'partner.remove': '삭제',
  'partner.close': '파트너 코드 닫기',
  'partner.referredBy': '추천인',
  'partner.partnerId': '파트너 ID',
  'partner.country': '국가',
  'partner.unavailable': '해당 코드를 확인할 수 없습니다. 다시 시도해 주세요.',

  // Step 2 — identity
  'identity.notReadyTitle': '계정 설정을 먼저 완료해 주세요',
  'identity.backToStep1': '1단계로 돌아가기',
  'identity.title': '신원 확인',
  'identity.subtitle':
    '규정에 따라 거래를 시작하시기 전에 본인 확인이 필요합니다. 약 2분이 소요됩니다.',
  'identity.startFailedTitle': '신원 확인을 시작하지 못했습니다',
  'identity.step1': '여권, 주민등록증 또는 운전면허증을 준비해 주세요.',
  'identity.step2': '신분증을 촬영한 뒤 간단한 셀피를 촬영하시게 됩니다.',
  'identity.step3': '브라우저가 요청할 때 카메라 접근을 허용해 주세요 — 없이는 확인이 진행되지 않습니다.',
  'identity.starting': '여는 중…',
  'identity.start': '신원 확인 시작',
  'identity.partnerNote': '신원 확인 파트너 페이지로 이동한 뒤 이곳으로 바로 돌아옵니다.',
  'identity.inProgress': '이미 시작하셨습니다. 계속하시면 진행하던 곳부터 이어집니다.',
  'webview.title': '브라우저에서 이 페이지를 열어 주세요',
  'webview.cameraWarn': '{browser}에서는 카메라가 작동하지 않는 경우가 많으며, 신원 확인에는 카메라가 필요합니다.',
  'webview.namedBrowser': '{app}의 내장 브라우저',
  'webview.thisBrowser': '이 앱의 내장 브라우저',
  'webview.iosInstruction': '공유 아이콘을 누른 뒤 Safari로 열기를 선택하세요.',
  'webview.openInChrome': 'Chrome으로 열기',
  'webview.androidInstruction': '또는 메뉴에서 브라우저로 열기를 선택하세요.',
  'webview.otherInstruction': '이 페이지의 주소를 평소 사용하는 브라우저에 붙여넣으세요.',

  // Post-KYC — confirm details
  'confirm.title': '정보 확인',
  'confirm.subtitle': '신분증에서 읽어 채워 넣었습니다 — 맞는지 확인하시고 틀린 부분은 수정해 주세요.',
  'confirm.saveFailedTitle': '정보를 저장하지 못했습니다',
  'confirm.idOutstandingTitle': '신분증이 아직 필요합니다',
  'confirm.idOutstandingBody':
    '신원 확인이 완료되지 않아 아래에 정보를 직접 입력해 주세요. 그대로 진행하여 마치시면 됩니다 — 서류는 이메일로 안내해 드립니다.',
  'confirm.firstName': '이름',
  'confirm.lastName': '성',
  'confirm.dob': '생년월일',
  'confirm.whereLive': '어디에 거주하십니까?',
  'confirm.city': '시/군/구',
  'confirm.state': '시/도',
  'confirm.saving': '저장 중…',

  // Step 3 — compliance
  'compliance.stillCheckingTitle': '신분증을 확인하고 있습니다',
  'compliance.backToVerification': '신원 확인으로 돌아가기',
  'compliance.loading': '설문을 불러오는 중…',
  'compliance.loadFailedTitle': '설문을 불러오지 못했습니다',
  'compliance.stillStuck': '계속 진행되지 않으시나요?',
  'compliance.title': '마지막 몇 가지 질문',
  'compliance.subtitle':
    '계좌 개설 전 규정에 따라 여쭤보아야 하는 항목입니다. 답변은 신청 내역과 함께 보관됩니다.',
  'compliance.submitting': '제출 중…',
  'compliance.submit': '제출',
  'compliance.oneQuestionLeft': '아직 답변하지 않은 질문이 1개 있습니다.',
  'compliance.questionsLeft': '아직 답변하지 않은 질문이 {count}개 있습니다.',
  'compliance.saveAnswersFailed': '답변을 저장하지 못했습니다',

  // Shared step gate
  'gate.stepToFinishTitle': '먼저 완료해야 할 단계가 있습니다',
  'gate.continueWhereLeft': '진행하던 곳부터 계속하기',

  // Step 4 — finish
  'done.loadingDocs': '마지막 서류를 불러오는 중…',
  'done.loadFailedTitle': '서류를 불러오지 못했습니다',
  'done.tryAgainMoment': '잠시 후 다시 시도해 주세요.',
  'done.title': '마지막 한 가지',
  'done.readyToSubmit': '신청서를 제출할 준비가 되었습니다.',
  'done.pleaseAccept': '계좌를 개설하기 전에 아래 내용을 읽고 동의해 주세요.',
  'done.agreeAll': '{count}개 서류를 모두 읽었으며 이에 동의합니다',
  'done.hideDocs': '서류 숨기기',
  'done.showDocs': '서류 {count}개 보기',
  'done.version': '버전 {version}',
  'done.finishing': '마무리하는 중…',
  'done.finishSignIn': '완료하고 로그인',
  'done.oneLeft': '아직 동의하지 않은 서류가 1개 있습니다.',
  'done.docsLeft': '아직 동의하지 않은 서류가 {count}개 있습니다.',
  'done.straightIn': '계정으로 바로 이동합니다 — 다시 로그인하실 필요는 없습니다.',
  'done.completeFailed': '신청을 완료하지 못했습니다',
  'done.acceptEvery': '모든 서류에 동의해 주세요',
  'done.getApps': '거래 앱 받기',
  'done.getAppsSubtitle': '계좌가 개설되면 MT5 또는 KCM Trade 앱으로 거래하시게 됩니다.',
  'done.onComputer': '컴퓨터로 보고 계신가요?',
  'done.scanQr': 'QR 코드를 스캔',
  'done.scanQrSuffix': '하시면 휴대폰에 앱을 설치할 수 있습니다.',

  // KYC outcomes
  'kyc.approvedTitle': '신원이 확인되었습니다',
  'kyc.approvedBody': '감사합니다 — 가장 번거로운 단계가 끝났습니다.',
  'kyc.reviewTitle': '서류를 검토하고 있습니다',
  'kyc.reviewBody':
    '담당자가 확인하고 있습니다 — 보통 몇 시간이면 끝나며, 완료되는 즉시 이메일로 알려드립니다. 여기서 기다리실 필요는 없습니다. 나머지를 계속 진행해 주세요.',
  'kyc.questions': '궁금한 점이 있으신가요?',
  'kyc.declinedTitle': '신원을 확인하지 못했습니다',
  'kyc.contactPrefix': '문의처',
  'kyc.contactSuffix': '으로 연락 주시면 도와드리겠습니다.',
  'kyc.expiredTitle': '세션 시간이 초과되었습니다',
  'kyc.expiredBody': '신원 확인 세션은 오래 유지되지 않습니다. 다시 시작하는 데 몇 분이면 됩니다.',
  'kyc.continueAnyway': '신청 계속하기',
  'kyc.finishLaterBody':
    '남은 신청 절차는 지금 마치실 수 있습니다. 신분증에 관해서는 별도로 이메일을 보내드리며, 처리될 때까지 계정은 대기 상태로 유지됩니다.',
  'decline.document_unreadable':
    '신분증 사진이 선명하지 않아 읽을 수 없었습니다. 밝은 곳에서 평평한 곳에 두고 촬영하시면 대개 해결됩니다.',
  'decline.face_mismatch': '셀피가 신분증 사진과 일치하지 않았습니다.',
  'decline.document_expired': '사용하신 신분증의 유효기간이 지났습니다.',
  'decline.other': '자동 확인 절차로는 신원을 확인할 수 없었습니다.',

  // Didit return
  'verify.checkFailedTitle': '상태를 확인하지 못했습니다',
  'verify.checkFailedBody': '신원 확인은 제출되었습니다. 이 페이지를 새로고침하면 대개 해결됩니다.',
  'verify.refresh': '새로고침',
  'verify.stillProcessingTitle': '처리 중입니다',
  'verify.stillProcessingBody':
    '평소보다 오래 걸리고 있습니다. 서류는 제출되었고 없어진 것은 없습니다 — 결과가 나오는 즉시 이메일로 알려드립니다.',
  'verify.back': '뒤로',
  'verify.checkingTitle': '서류를 확인하고 있습니다',
  'verify.checkingBody': '보통 몇 초면 끝납니다. 이 페이지를 닫지 마세요.',
  'verify.checkingAria': '신원 확인을 확인하는 중',
  'handoff.receivedTitle': '서류를 받았습니다',
  'handoff.receivedBody': '감사합니다 — 휴대폰에서 필요한 것은 모두 받았습니다.',
  'handoff.goBackTitle': '이제 컴퓨터로 돌아가 주세요',
  'handoff.goBackBody':
    '신청서는 처음 시작하신 브라우저에 그대로 열려 있습니다. 거기에서 마무리해 주세요 — 확인이 끝나면 페이지가 자동으로 넘어갑니다.',
  'handoff.closeTab': '이 탭은 닫으셔도 됩니다.',
  'handoff.somethingWrong': '문제가 있으신가요?',
}
